import {
  ADD_BILLINGCONSOLIDATEDINVOICE,
  ADD_BILLINGGENERATEINVOICE,
  ADD_BILLINGPRICEDETAILS,
  ADD_BILLINGREQUESTAPPROVAL,
  GET_BILLINGCONSOLIDATEDINVOICE,
  GET_BILLINGEXTRACHARGECALCULATION,
  GET_BILLINGINVOICEDETAILS,
  GET_BILLINGLIST,
  GET_BILLINGPRICEDETAILS,
  GET_CONSOLIDATE_INVOICE_MATRIX,
  GET_FINAL_INVOICE,
  ADD_BILLINGREQUESTAPPROVALLINK,
  GENERATE_CONSOLIDATED_PAYMENT_LINK,
  GET_CONSOLIDATED_PAYMENT_LINK,
  CHECK_CONSOLIDATED_PAYMENT_STATUS,
  CANCEL_CONSOLIDATED_PAYMENT_LINK,
  PATCH_INVOICE_TAXES,
  SEND_CONSOLIDATED_INVOICE_EMAIL,
  GET_BILLING_EMPLOYEES,
  GET_BILL_SELF_ELIGIBLE_INVOICES,
  GENERATE_BILL_SELF_CONSOLIDATED_INVOICE,
  GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST,
  GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS,
} from "resources/actionTypes";

export function getBillingList(payload) {
  return {
    type: GET_BILLINGLIST.GET_BILLINGLIST_REQUESTED,
    payload: payload,
  };
}

export function clearBillingList() {
  return {
    type: GET_BILLINGLIST.GET_BILLINGLIST_CLEARED,
  };
}
export function clearFinalInvoice() {
  return {
    type: GET_FINAL_INVOICE.GET_FINAL_INVOICE_CLEARED,
  };
}
//Price Invoice Details
export function getBillingInvoiceDetails(id, type) {
  const payloadData = {
    id: id,
    type: type,
  };
  return {
    type: GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_REQUESTED,
    payload: payloadData,
  };
}
// Generate Link
export function generateConsolidatedPaymentLink(
  consolidatedInvoiceId,
  callback,
) {
  return {
    type: GENERATE_CONSOLIDATED_PAYMENT_LINK.GENERATE_CONSOLIDATED_PAYMENT_LINK_REQUESTED,
    payload: { consolidatedInvoiceId, callback },
  };
}

// Read Link
export function getConsolidatedPaymentLink(consolidatedInvoiceId, callback) {
  return {
    type: GET_CONSOLIDATED_PAYMENT_LINK.GET_CONSOLIDATED_PAYMENT_LINK_REQUESTED,
    payload: { consolidatedInvoiceId, callback },
  };
}

// Check Status
export function checkConsolidatedPaymentStatus(
  consolidatedInvoiceId,
  callback,
) {
  return {
    type: CHECK_CONSOLIDATED_PAYMENT_STATUS.CHECK_CONSOLIDATED_PAYMENT_STATUS_REQUESTED,
    payload: { consolidatedInvoiceId, callback },
  };
}

// Cancel Link
export function cancelConsolidatedPaymentLink(consolidatedInvoiceId, callback) {
  return {
    type: CANCEL_CONSOLIDATED_PAYMENT_LINK.CANCEL_CONSOLIDATED_PAYMENT_LINK_REQUESTED,
    payload: { consolidatedInvoiceId, callback },
  };
}
//Price Invoice Details
export function getBillingPrice(payload) {
  return {
    type: GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_REQUESTED,
    payload: payload,
  };
}

export function getBillingCharges(payload) {
  const payloadData = {
    tripId: payload?.tripId,
    extraTime: payload?.extraTime,
    extraDistance: payload?.extraDistance,
  };

  return {
    type: GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_REQUESTED,
    payload: payloadData,
  };
}

export function addBillingPrice(payload, id, handleNavigate) {
  const payloadData = {
    obj: payload,
    id: id,
    navigate: handleNavigate,
  };

  return {
    type: ADD_BILLINGPRICEDETAILS.ADD_BILLINGPRICEDETAILS_REQUESTED,
    payload: payloadData,
  };
}

export function addBillingRequestApproval(payload, toggle) {
  const payloadData = {
    dataObj: payload,
    toggle: toggle,
  };
  return {
    type: ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_REQUESTED,
    payload: payloadData,
  };
}

export function addBillingConsolidatedInvoice(
  payload,
  billingListPayload,
  handleTotalAmount,
) {
  const payloadData = {
    dataObj: payload,
    billingListPayload: billingListPayload,
    handleTotalAmount: handleTotalAmount,
  };
  return {
    type: ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_REQUESTED,
    payload: payloadData,
  };
}

export function getBillingConsolidatedInvoiceDetails(id, type) {
  const payload = {
    id: id,
    type: type,
  };
  return {
    type: GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_REQUESTED,
    payload: payload,
  };
}

export function generateInvoice(payload) {
  return {
    type: ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_REQUESTED,
    payload: payload,
  };
}

export function getConsolidateInvoiceMatrix(id, type) {
  const payload = {
    id: id,
    type: type,
  };
  return {
    type: GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_REQUESTED,
    payload: payload,
  };
}

export function getFinalInvoice(payload) {
  return {
    type: GET_FINAL_INVOICE.GET_FINAL_INVOICE_REQUESTED,
    payload: payload,
  };
}

// Add billing Request Link
export function addBillingRequestApprovalLink(payload, toggle) {
  const payloadData = {
    dataObj: payload,
    toggle: toggle,
  };
  return {
    type: ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_REQUESTED,
    payload: payloadData,
  };
}

export function patchInvoiceTaxes(
  tripId,
  payload,
  isPrivate,
  magicToken,
  onSuccess,
) {
  return {
    type: PATCH_INVOICE_TAXES.PATCH_INVOICE_TAXES_REQUESTED,
    payload: { tripId, payload, isPrivate, magicToken, onSuccess },
  };
}

// Send Consolidated Invoice Email
export function sendConsolidatedInvoiceEmail(invoiceId, recipients, callback) {
  return {
    type: SEND_CONSOLIDATED_INVOICE_EMAIL.SEND_CONSOLIDATED_INVOICE_EMAIL_REQUESTED,
    payload: { invoiceId, recipients, callback },
  };
}

// Get Billing Employees
export const getBillingEmployees = (
  companyId,
  page = 1,
  pageSize = 100,
  status = "Approved",
) => ({
  type: GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_REQUESTED,
  payload: { companyId, page, pageSize, status },
});

export function clearBillingEmployees() {
  return {
    type: GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_CLEAR,
  };
}

// Get Eligible Bill-Self Invoices
export function getBillSelfEligibleInvoices(
  companyId,
  cityId,
  employeeId,
  page,
  pageSize,
  dateFrom,
  dateTo,
) {
  return {
    type: GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_REQUESTED,
    payload: { companyId, cityId, employeeId, page, pageSize, dateFrom, dateTo, },
  };
}

export function clearBillSelfEligibleInvoices() {
  return {
    type: GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_CLEAR,
  };
}

// Generate Bill-Self Consolidated Invoice
export function generateBillSelfConsolidatedInvoice(
  payload,
  billingListPayload,
  onSuccess,
) {
  return {
    type: GENERATE_BILL_SELF_CONSOLIDATED_INVOICE.GENERATE_BILL_SELF_CONSOLIDATED_INVOICE_REQUESTED,
    payload: { payload, billingListPayload, onSuccess },
  };
}

// Get Bill-Self Consolidated Invoices List
export function getBillSelfConsolidatedInvoicesList(payload) {
  return {
    type: GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_REQUESTED,
    payload: payload,
  };
}

export function clearBillSelfConsolidatedInvoicesList() {
  return {
    type: GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_CLEAR,
  };
}

// Get Bill-Self Consolidated Invoice Details
export function getBillSelfConsolidatedInvoiceDetails(id) {
  return {
    type: GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS.GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS_REQUESTED,
    payload: { id },
  };
}
